import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/questionType/page',
  ADD: '/dh-datamaint/questionType/add',
  DELETE: '/dh-datamaint/questionType/delete',
  DETAIL: '/dh-datamaint/questionType/detail',
  UPDATE: '/dh-datamaint/questionType/update',
  SORT: '/dh-datamaint/questionType/sort',
  GET_SORT: '/dh-datamaint/questionType/count',
  LIST: '/dh-datamaint/questionType/listAll'
};

class QuestionTypeModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async Sort(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async getSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_SORT, { params: payload.data });
    },

    async getQTList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.LIST, { params: payload.data });
    }
  };
}

export const questionTypeModule = new QuestionTypeModule();
